<template>
  <v-container>
    <v-menu offset-y style="float:right">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          style="float:right"
          v-bind="attrs"
          v-on="on"
          @click="loadFiles"
        >
          <v-icon>text_snippet</v-icon>
        </v-btn>
      </template>
      <v-list dense
        ><v-subheader>Voir les pièces du dossier :</v-subheader>
        <v-list-item v-if="loading">
          <v-row justify="space-around">
            <v-progress-circular size="50" indeterminate color="primary">
            </v-progress-circular>
          </v-row>
        </v-list-item>
        <v-list-item v-for="(file, index) in files" :key="index" v-else>
          <v-btn :href="file.url" text download>{{ file.name }}</v-btn>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-container>
</template>

<script>
import common from "@/common";
import ApiDossierRepository from "@/repositories/ApiDossierRepository";

export default {
  name: "LinkToPDFWidget",
  props: ["dossier"],
  data() {
    return {
      files: [{ name: "Pas de fichier", url: false }],
      loading: false
    };
  },
  computed: {},
  methods: {
    async loadFiles() {
      this.files = [];
      this.loading = true;
      this.files.push({
        name: "Dossier (PDF)",
        url: common.getPDFURL(this.dossier)
      });
      const justificatifs = await ApiDossierRepository.getJustificatifs(
        this.dossier.id
      );
      if (
        justificatifs &&
        Array.isArray(justificatifs) &&
        justificatifs.length
      ) {
        for (const justificatif of justificatifs) {
          this.files.push({
            name: justificatif.name,
            url: ApiDossierRepository.getJustificatifURL(justificatif)
          });
        }
      }

      this.loading = false;
    },

    linkToPDF(dossier) {
      return common.getPDFURL(dossier);
    }
  }
};
</script>

<style></style>
